"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _solarReact = require("@solar/solar-react");

var _ui = require("@probeton/ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DownloadTable = function DownloadTable(_ref) {
  var downloads = _ref.downloads,
      openCustomer = _ref.openCustomer,
      certificateKey = _ref.certificateKey;

  var renderRowItem = function renderRowItem(_ref2) {
    var _author$person$fullNa, _author$person, _author$person2, _author$email;

    var formattedDate = _ref2.formattedDate,
        fileName = _ref2.document.fileName,
        author = _ref2.author,
        certificate = _ref2.certificate;
    return {
      customerId: author._id,
      fileName: fileName,
      certificateKey: certificateKey || (certificate === null || certificate === void 0 ? void 0 : certificate.key),
      formattedDate: formattedDate,
      profileShared: (_author$person$fullNa = !!(author !== null && author !== void 0 && (_author$person = author.person) !== null && _author$person !== void 0 && _author$person.fullName)) !== null && _author$person$fullNa !== void 0 ? _author$person$fullNa : false,
      author: /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
        textLabel: author === null || author === void 0 ? void 0 : (_author$person2 = author.person) === null || _author$person2 === void 0 ? void 0 : _author$person2.fullName,
        text: (_author$email = author === null || author === void 0 ? void 0 : author.email) !== null && _author$email !== void 0 ? _author$email : 'profiel niet meer gedeeld',
        style: _objectSpread({
          padding: 0
        }, !(author !== null && author !== void 0 && author.email) ? {
          color: 'rgba(0,0,0,0.2)'
        } : {})
      })
    };
  };

  return /*#__PURE__*/_react["default"].createElement(_solarReact.VirtualizedTable, {
    headerHeight: 64,
    rowHeight: 64,
    rowCount: downloads.length,
    rowGetter: function rowGetter(_ref3) {
      var index = _ref3.index;
      return renderRowItem(downloads[index]);
    },
    onRowClick: function onRowClick(item) {
      var _item$rowData = item.rowData,
          customerId = _item$rowData.customerId,
          profileShared = _item$rowData.profileShared;

      if (profileShared) {
        openCustomer(customerId);
      }
    },
    columns: [{
      width: 100,
      flexGrow: 0,
      label: 'Certificaat',
      dataKey: 'certificateKey'
    }, {
      width: 240,
      flexGrow: 1.0,
      label: 'Downloader',
      dataKey: 'author'
    }, {
      width: 240,
      flexGrow: 1.0,
      label: 'Bestand',
      dataKey: 'fileName'
    }, {
      width: 140,
      flexGrow: 0,
      label: 'Datum',
      dataKey: 'formattedDate'
    }]
  });
};

var _default = DownloadTable;
exports["default"] = _default;